import CellEditTextField from "./CellEditTextField";
import { CURRENT_TICKET_OR_CASE_NUMBER } from "../../../constants";
import SbuxTranslate from "../../../components/SbuxTranslate";
import type { GridRenderCellParams } from "@mui/x-data-grid";
export const getDataGridColumns = (
  ccpContactStatus: string | null,
  ccpContactMethod: string | null,
  ticketOrCaseFeatureFlagEnabled: boolean,
) => {
  const config = [
    {
      headerName: "Name",
      field: "name",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (cellValues: GridRenderCellParams) => (
        <SbuxTranslate>{String(cellValues.value ?? "")}</SbuxTranslate>
      ),
    },
    {
      headerName: "Value",
      field: "value",
      flex: 1,
      minWidth: 400,
      type: "string",
      sortable: false,
      renderCell: (cellValues: GridRenderCellParams) => {
        return cellValues.row.name === CURRENT_TICKET_OR_CASE_NUMBER ? (
          <CellEditTextField
            defaultValue={cellValues.value}
            ccpContactStatus={ccpContactStatus}
            ccpContactMethod={ccpContactMethod}
            ticketOrCaseFeatureFlagEnabled={ticketOrCaseFeatureFlagEnabled}
          />
        ) : (
          <span>{cellValues.value}</span>
        );
      },
    },
  ];

  return config.slice();
};
